import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Toaster as Sonner } from 'sonner';

import { useTheme } from '../ThemeProvider';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { variant } = useTheme();
  const { i18n } = useTranslation();

  useEffect(() => {
    const updateLabel = () => {
      let language = i18n.resolvedLanguage;
      try {
        language = localStorage.getItem('fongpt-language') || language;
      } catch {
        // Keep i18n's current language when local storage is unavailable.
      }
      const label = language?.toLowerCase().startsWith('sr')
        ? 'Obaveštenja'
        : 'Notifications';
      document
        .querySelectorAll('section[aria-live="polite"][aria-relevant]')
        .forEach((node) => node.setAttribute('aria-label', label));
    };
    updateLabel();
    const observer = new MutationObserver(updateLabel);
    observer.observe(document.body, { childList: true, subtree: true });
    const timer = window.setTimeout(updateLabel, 100);
    return () => {
      observer.disconnect();
      window.clearTimeout(timer);
    };
  }, [i18n.language, i18n.resolvedLanguage]);

  return (
    <Sonner
      theme={variant}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton:
            'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton:
            'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground'
        }
      }}
      {...props}
    />
  );
};

export { Toaster };
